// See: backend/docs/arvento-telemetry.md §20.1
// Kritik servissiz-kullanım uyarısı rozeti. Yalnızca Telemetri görünümünde.
// Uyarı Merkezi'nde gösterilmez. Link Uyarı Merkezi sekmesine gider.

import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import "./CriticalAlertBadge.css";

/**
 * @param {number} count - ŞU AN servis dışı çalışan araç sayısı (canlı; araç durunca sıfırlanır)
 * @param {boolean} asLink - true ise Uyarı Merkezi'ne link (Telemetri içinde), false ise düz rozet
 */
const CriticalAlertBadge = ({ count = 0, asLink = true }) => {
  const { t } = useTranslation();
  const hasAlerts = count > 0;
  const content = (
    <div className={`critical-alert-badge ${hasAlerts ? "critical-alert-badge--active" : "critical-alert-badge--ok"}`}>
      <WarningAmberIcon className="critical-alert-badge__icon" />
      <span className="critical-alert-badge__text">
        {hasAlerts ? t("telemetryServicelessVehicleCount", { count }) : t("telemetryNoServicelessUse")}
      </span>
    </div>
  );

  if (asLink) {
    return (
      <Link to="/live?tab=telemetryAlerts" className="critical-alert-badge__link" title={t("telemetryAlertCenter")}>
        {content}
      </Link>
    );
  }
  return content;
};

export default CriticalAlertBadge;
